module.exports = __webpack_public_path__ + "img/dzgsdt.0cc436de.png";